import { i18n } from "@src/i18n/i18n";
import { warningSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { OurNodeset } from "../poc/our-nodeset";
import { getLogger } from "../dependency-injection-container/get-logger";
import store from "@src/reducers/store";

const oldCheck = (machineStructureRootNode, maximumAmountOfMonitoringNodes) => {
  const countNodesWithMonitoringAcquisitionType = (node) => {
    let count = 0;

    if (
      node.attributes &&
      node.attributes.node_class_as_string === "VARIABLE" &&
      node.attributes.data_acquisition_type === "MONITORING"
    ) {
      count += 1;
    }

    if (node.children) {
      node.children.forEach((child) => {
        count += countNodesWithMonitoringAcquisitionType(child);
      });
    }

    return count;
  };

  const checkIfMaximumAmountOfMonitoringNodesIsExceeded = (
    newNodeStructure,
    maximumAmountOfMonitoringNodes,
  ) => {
    const count = countNodesWithMonitoringAcquisitionType(newNodeStructure);
    return count > maximumAmountOfMonitoringNodes;
  };

  const isMaximumMonitoringThresholdReached =
    checkIfMaximumAmountOfMonitoringNodesIsExceeded(
      machineStructureRootNode,
      maximumAmountOfMonitoringNodes,
    );

  if (isMaximumMonitoringThresholdReached) {
    warningSnackbar(
      i18n(
        "modules.snackbarNotifications.maximumAmountOfMonitoringNodesExceededNotification",
      ),
      10000,
    );
  }
};

const newCheck = (machineStructureRootNode, maximumAmountOfMonitoringNodes) => {
  const language = store.getState().yourSlice.language;
  const texts = {
    notification: i18n(
      "modules.snackbarNotifications.maximumAmountOfMonitoringNodesExceededNotification",
      language,
    ),
  };

  const notificationDuration = 10000;

  const isMaximumMonitoringThresholdReached = (
    machineStructureRootNodeset: OurNodeset,
    maximumAmountOfMonitoringNodes: number,
  ): boolean => {
    let count = 0;

    machineStructureRootNodeset.getFlatMap().forEach((node) => {
      if (
        node.node_type === "VARIABLE" &&
        node.attributes &&
        node.attributes.data_acquisition_type === "MONITORING"
      ) {
        count++;
      }
    });

    return count > maximumAmountOfMonitoringNodes;
  };

  if (
    isMaximumMonitoringThresholdReached(
      machineStructureRootNode,
      maximumAmountOfMonitoringNodes,
    )
  ) {
    warningSnackbar(texts.notification, notificationDuration);
  }
};

export const sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded =
  (
    machineStructureRootNodeset: any | OurNodeset,
    maximumAmountOfMonitoringNodes,
  ) => {
    getLogger().debug(
      "sendSnackbarNotificationWhenMaximumAmountOfMonitoringNodesIsExceeded",
      {
        machineStructureRootNodeset: machineStructureRootNodeset,
        maximumAmountOfMonitoringNodes: maximumAmountOfMonitoringNodes,
      },
    );

    newCheck(machineStructureRootNodeset, maximumAmountOfMonitoringNodes);
  };
